import { render, staticRenderFns } from "./IcLoading.vue?vue&type=template&id=7ff0de4e&scoped=true"
import script from "./IcLoading.vue?vue&type=script&lang=js"
export * from "./IcLoading.vue?vue&type=script&lang=js"
import style0 from "./IcLoading.vue?vue&type=style&index=0&id=7ff0de4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff0de4e",
  null
  
)

export default component.exports